<template>
    <div>
        <template v-if="!canCreateBasicOrders">
            <full-create :parent-order="parentOrder" />
        </template>
        <div class="orders-create" v-else>
            <div class="columns" style="background-color:#777;margin:0;" >
                <div class="column is-6" >
                    <basic-create :parent-order="parentOrder" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BasicCreate from "./basic";
    import FullCreate from "./full";
    export default {
		props: {
			parentOrder: {
				type: Object
			}
		},
        components: { BasicCreate, FullCreate },
        computed: {
            canCreateBasicOrders(){
              return this.$store.getters["Auth/hasFirmPermission"]("can create basic orders");
            },
        }
    };
</script>

<style lang="scss" scoped>

    .form {
      .scrollable {
        height: calc(100vh - 104px - 1.5rem - 0.85rem - 1.5rem - 82px);
      }
    }

    .detail {
      .scrollable {
        height: calc(100vh - 104px - 1.5rem - 0.85rem - 1.5rem);
      }
    }

    .overlay {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(255, 255, 255, 0.3);
      z-index: 9;
    }

    .field-label .label {
      white-space: normal;
    }

</style>


// WEBPACK FOOTER //
// src/components/pages/Orders/create/index.vue